const InvoiceIcon = () => {
    return ( 
        <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.50008 4.83333H5.33341M4.50008 9.83333H9.50008M7.83342 13.1667H9.50008M11.1667 16.5H2.83341C2.39139 16.5 1.96746 16.3244 1.6549 16.0118C1.34234 15.6993 1.16675 15.2754 1.16675 14.8333V3.16667C1.16675 2.72464 1.34234 2.30072 1.6549 1.98816C1.96746 1.67559 2.39139 1.5 2.83341 1.5H8.66675L12.8334 5.66667V14.8333C12.8334 15.2754 12.6578 15.6993 12.3453 16.0118C12.0327 16.3244 11.6088 16.5 11.1667 16.5Z" stroke="#4D4D4D" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="stroke" />
            <defs>
            <linearGradient id="paint0_linear_145_371" x1="0.166748" y1="0.166707" x2="16.8334" y2="16.8334" gradientUnits="userSpaceOnUse">
                <stop stopColor="#FF512F"/>
                <stop offset="1" stopColor="#DD2476"/>
            </linearGradient>
            </defs>
        </svg>

    );
}
 
export default InvoiceIcon;